import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { formatPhoneNumber, getCountryByHostname, stripLeadingZeros, stripNonNumerics } from '@/helpers';
import { GuestInfoForm } from '@/store/checkout';
import { GuestInfoField } from '@/services/checkout/checkout.service';
import { OrderWithContext } from '@/models';
import { CountryCode } from '@/store/ui';
import { ui } from '@/constants';

@Component({
  name: 'CmgCheckoutGuestInfoForm',
})
export default class CmgCheckoutGuestInfoForm extends Vue {
  sentCheckoutEvent = false;

  get form(): GuestInfoForm {
    return this.$appStore.state.checkout.guest.info;
  }

  get order(): OrderWithContext | null {
    return this.$services.order.getCurrentOrder();
  }

  get maxPhoneLength(): number {
    return !this.isUKGuest ? 11 : 15;
  }

  get isUKGuest(): boolean {
    return this.$appStore.state.ui.countryProfile.countryCode === CountryCode.GB 
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }

  mounted() {
    const numberValue = this.$appStore.state.checkout.guest.info.phoneNumber.value;
    if (!this.$appStore.state.checkout.guest.info.phoneNumber.formatted && numberValue) {
      this.$appStore.state.checkout.guest.info.phoneNumber.formatted = this.formatPhoneNumber(numberValue);
    }
    if(!this.$appStore.state.ui.countryInitialized) {
      const countryProfile = getCountryByHostname(window.location.hostname);
      this.$services.ui.setCountryProfile(countryProfile, false);
    }
    this.$appStore.state.checkout.guest.info.countryCode.value = this.$appStore.state.ui.countryProfile.countryCode;
  }

  formatPhoneNumber(value: string): string { 
    return this.isUKGuest ? value : formatPhoneNumber(value, this.$appStore.state.ui.countryProfile.countryCode);
  }

  sanitizePhoneNumber(value: string): string {
    return this.isUKGuest 
      ? stripNonNumerics(value) 
      : stripLeadingZeros(stripNonNumerics(value));
  }

  validateField(field: GuestInfoField) {
    this.validateForm(field);
  }

  onBlurContactInfoField(): void {
    if (this.isGuestInfoComplete() && !this.sentCheckoutEvent && this.order) {
      this.sentCheckoutEvent = true;
      this.$services.googleAnalytics.sendEcommerceCheckoutEvent(this.order, 'contact info', 3);
    }
  }

  onBlurPhoneNumberField(event: any): void {
    this.onBlurContactInfoField();
    if (event.target.value) {
      this.setDeliveryPhoneNumbers(event.target.value);
    }
  }

  setDeliveryPhoneNumbers(phoneNumber: string) {
    const profile = this.$appStore.state.customer.profile;
    if (profile && profile.isGuest) {
      this.$services.checkout.setGuestInfoPhoneNumber(phoneNumber);
    }

    this.$services.order.setOrderPhoneNumber(phoneNumber);
    this.$services.checkout.setDeliveryPhoneNumber(phoneNumber);
  }

  private validateForm(field: GuestInfoField) {
    this.$services.checkout.validateGuestInfo([field], this.isMobile);
  }

  private isGuestInfoComplete(): boolean {
    return !!this.form.customerName.value &&
      !!this.form.phoneNumber.value &&
      !!this.form.email.value;
  }
}
